import React from 'react';
import MypageContainer from 'containers/MypageContainer/MypageContainer';

export default function MypagePage() {
    return (
        <MypageContainer />
    )
}
